import { render, staticRenderFns } from "./DeepDive.vue?vue&type=template&id=01f0b5c8&scoped=true&"
import script from "./DeepDive.vue?vue&type=script&setup=true&lang=js&"
export * from "./DeepDive.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DeepDive.vue?vue&type=style&index=0&id=01f0b5c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0b5c8",
  null
  
)

export default component.exports